import * as yup from 'yup';
import { TFunction } from 'react-i18next';
import rgx from 'constants/regex';
import { imageValidation } from 'utils/yup';

export const CreateForm = (t: TFunction): yup.ObjectSchema<any> =>
  yup.object({
    title: yup.string().required(t('form-schemas.title-is-required')),
    titleColor: yup
      .string()
      .required(t('form-schemas.title-color-is-required'))
      .matches(rgx.hexadecimalColorFormat, t('form-schemas.hexadecimal-color-format')),
    backgroundColor: yup.string().when('backgroundMainImage', {
      is: (val) => val == null,
      then: () =>
        yup
          .string()
          .required(t('form-schemas.background-color-is-required'))
          .matches(rgx.hexadecimalColorFormat, t('form-schemas.hexadecimal-color-format')),
      otherwise: () => yup.string(),
    }),
    buttonColor: yup
      .string()
      .required(t('form-schemas.button-color-is-required'))
      .matches(rgx.hexadecimalColorFormat, t('form-schemas.hexadecimal-color-format')),
    buttonTextColor: yup
      .string()
      .required(t('form-schemas.button-color-is-required'))
      .matches(rgx.hexadecimalColorFormat, t('form-schemas.hexadecimal-color-format')),
    active: yup.boolean().required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.active') })),
    conectionTime: yup
      .number()
      .required(t('form-schemas.connection-time-is-required'))
      .typeError(t('form-schemas.connection-time-must-number')),
    urlToWeb: yup.string(),
    showEmail: yup.boolean().required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.email') })),
    showIdentificationNumber: yup
      .boolean()
      .required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.identification-number') })),
    showPhone: yup.boolean().required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.phone') })),
    showAgeRange: yup.boolean().required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.age-range') })),
    showFullname: yup.boolean().required(t('form-schemas.checkbox-is-required', { type: t('form-schemas.fullname') })),
    venueId: yup.string().required(t('form-schemas.venue-is-required')),
    promotionBannerImage: imageValidation(t('form-schemas.banner-image'), false),
    backgroundMainImage: imageValidation(t('form-schemas.background-image'), false),
    backgroundHeaderImage: imageValidation(t('form-schemas.header-image'), false),
    backgroundFooterImage: imageValidation(t('form-schemas.footer-image'), false),
  });

export const AgeRangeConfigForm = (t: TFunction): yup.ObjectSchema<any> =>
  yup.object({
    fromAge: yup.number().required(t('form-schemas.is-required')).min(1),
    toAge: yup.number().required(t('form-schemas.is-required')),
  });
